var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'btn-switch' + (_vm.size ? ` btn-${_vm.size}` : '')},_vm._l((_vm.options),function(option){return _c('span',{key:option.value,class:'btn-switch-option' + (option.value === _vm.value ? ' active' : ''),on:{"click":function($event){return _vm.onClickOption(option.value)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }